export const FLOOR_IMAGE_LOAD_START = 'FLOOR_IMAGE_LOAD_START';
export const FLOOR_IMAGE_LOAD_DONE = 'FLOOR_IMAGE_LOAD_DONE';
export const FLOOR_IMAGE_LOAD_FAIL = 'FLOOR_IMAGE_LOAD_FAIL';
